import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Receipt, Users, CodeXml, SquareKanban, CircuitBoard } from "lucide-react";
import { useQuery } from "../AppLayout";
import GeneralSetting from "./GeneralSetting";
import SubscriptionSetting from "./SubscriptionSetting";
import BillingSetting from "./BillingSetting";
import MemberSetting from "./MemberSetting";
import PipelineSetting from "./PipelineSetting";
import DeveloperSetting from "./DeveloperSetting";
import SettingTabs from "./component/SettingTabs";

const TeamSetting = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { projectId }: any = useParams();
  const currentParams = useQuery();

  const settingType = currentParams.get("item") || "general";

  const currentUser = useSelector((state: any) => state.userReducer.get("currentUser"));
  const isAdmin = currentUser.get("admin");
  const tenantInfo = useSelector((state: any) => state.tenant.get("tenantInfo"));
  const isJira = tenantInfo.getIn(["host", "product"]) === "JIRA";

  useEffect(() => {
    document.title = t("Team Setting");
  }, [t]);

  const onSettingTypeChange = (type) => {
    navigate(`/workspaces/${projectId}/settings/team?item=${type}&key=Team%20Settings`);
  };

  const billingOrSubscription = {
    ...(isJira
      ? {
          id: "subscription",
          label: t("Subscriptions"),
          icon: <Receipt className="w-4 h-4" />,
        }
      : {
          id: "billing",
          label: t("Plan & Billing"),
          icon: <Receipt className="w-4 h-4" />,
        }),
  };

  const tabs = [
    {
      id: "general",
      label: t("General"),
      icon: <CircuitBoard className="w-4 h-4" />,
    },
    ...(isAdmin ? [billingOrSubscription] : []),
    {
      id: "member",
      label: t("Members"),
      icon: <Users className="w-4 h-4" />,
    },
    {
      id: "pipeline",
      label: t("Pipelines"),
      icon: <SquareKanban className="w-4 h-4" />,
    },
    {
      id: "developer",
      label: t("Developer"),
      icon: <CodeXml className="w-4 h-4" />,
    },
  ];

  return (
    <div className={"p-4"}>
      <SettingTabs tabs={tabs} activeTabId={settingType} onTabChange={onSettingTypeChange} />
      {settingType === "general" ? <GeneralSetting /> : null}
      {settingType === "subscription" && isAdmin && isJira ? <SubscriptionSetting /> : null}
      {settingType === "billing" && isAdmin && !isJira ? <BillingSetting /> : null}
      {settingType === "member" ? <MemberSetting /> : null}
      {settingType === "pipeline" ? <PipelineSetting /> : null}
      {settingType === "developer" ? <DeveloperSetting /> : null}
    </div>
  );
};

export default TeamSetting;
